import $ from "jquery";
import {frontPageSliderConfig} from './sliders-config';

export function initFrontPageSlider() {
  if($('.slider--home')) {
    const config = frontPageSliderConfig();
    
    $('.slider--home').slick(config);

    function setOverlayBgColor() {
      var backgroundColor = $('.slick-active .slider__item').data('bg-color');
      $('.dots-overlay').css('background-color', backgroundColor);
    };

    setOverlayBgColor();

    $('.slider--home').on('afterChange', function() {
      setOverlayBgColor();
    });
  } 
};
